import './Home.css';

function Home() {
  return (
    <div className="home">
      <section className="hero">
        <img src="/ohhell-logo.png" alt="Oh Hell Scoreboard Logo" className="app-logo" />
        <h1>Oh Hell Scoreboard</h1>
        <p className="tagline">Track your Oh Hell card game scores with ease</p>
        <div className="hero-buttons">
          <a 
            href="https://apps.apple.com/us/app/score-tracker-oh-hell/id6758681474" 
            className="store-badge"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/apple-store-badge.png" alt="Download on the App Store" />
          </a>
          <a 
            href="https://play.google.com/store/apps/details?id=com.ohhellscoreboard" 
            className="store-badge"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/google-play-badge.png" alt="Get it on Google Play" />
          </a>
        </div>
      </section>

      <section className="features-section">
        <h2>Features</h2>
        <div className="features-grid">
          <div className="feature-item">
            <h3>Easy Player Management</h3>
            <p>Support for 2-12 players with simple setup</p>
          </div>
          <div className="feature-item">
            <h3>Automatic Scoring</h3>
            <p>Let the app calculate scores automatically</p>
          </div>
          <div className="feature-item">
            <h3>Round Tracking</h3>
            <p>Navigate through rounds with ease</p>
          </div>
          <div className="feature-item">
            <h3>Cloud Backup</h3>
            <p>Google Drive backup support for your games</p>
          </div>
        </div>
      </section>

      <section className="support-section">
        <h2>Need Help?</h2>
        <p>
          For support, questions, or feedback, contact us at{' '}
          <a href="mailto:pixelsparadox0@gmail.com" className="email-link">
            pixelsparadox0@gmail.com
          </a>
        </p>
      </section>
    </div>
  );
}

export default Home;

